import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { connect } from "react-redux";
import { getDashboardProjectLikeStatus } from "../../../actions/dashboardActions";
import NoDataFound from "./noDataFound_Chart";
import ChartLoading from "./chartLoading";
import { useTranslation } from "react-i18next";
import "./style.css";

const options1 = {
	pieHole: 0.4,
	is3D: false,
	colors: ["#0B4A6F", "#065986", "#0086C9", "#0BA5EC", "#36BFFA"],
	chartArea: { left: 0, top: 20, width: "100%", height: "100%" },
	fontSize: 14,
	legend: { alignment: "center" },
};

const sumOfSecondElements = (arr) => {
	let sum = 0;
	arr.forEach((item) => {
		sum += item[1];
	});
	return sum;
};

const ProjectLikeStatus = ({
	isLoading,
	projectLikeStatus,
	getDashboardProjectLikeStatus,
	companyId,
}) => {
	const [data, setData] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		if (companyId) getDashboardProjectLikeStatus(companyId);
	}, [companyId]);

	useEffect(() => {
		const headerRow = [["CollegeName", "LikePercentage"]];
		let _data = [];

		if (projectLikeStatus && projectLikeStatus.length > 0) {
			projectLikeStatus.forEach((item) => {
				_data.push([item.studentCollege]);
			});
			const uniqueCounts = {};

			_data.forEach((item) => {
				const value = item[0];
				uniqueCounts[value] = (uniqueCounts[value] || 0) + 1;
			});

			const sum = _data.length;
			// Convert uniqueCounts object to an array of arrays
			const uniqueArrayWithCounts = Object.entries(uniqueCounts).map(
				([key, value]) => [
					`${key}: ${((value / sum) * 100).toFixed(1)}%`,
					value,
				]
			);

			setData([
				...headerRow,
				...uniqueArrayWithCounts.sort((a, b) => b[1] - a[1]),
			]);
		} else {
			setData([...headerRow, ..._data]);
		}
	}, [projectLikeStatus]);

	return (
		<div className="stat_container">
			<div className="stat_chart_title">
				{t("dashboard_sectiontitle_numberOfLikes")}
			</div>
			{isLoading && <ChartLoading />}
			{!isLoading && projectLikeStatus && projectLikeStatus.length > 0 && (
				<>
					<Chart
						chartType="PieChart"
						width="100%"
						height="200px"
						data={data.slice(0, 6)}
						options={options1}
					/>
					<div className="stat_chart_footer">
						{t("dashboard_sectionfooter_totalLikes_segment1")}{" "}
						<span className="highlight">
							{sumOfSecondElements(data.slice(1))}
						</span>{" "}
						{t("dashboard_sectionfooter_totalLikes_segment2")}
					</div>
				</>
			)}
			{!isLoading && !projectLikeStatus && <NoDataFound />}
		</div>
	);
};

const mapStateToProps = (state) => ({
	isLoading: state.dashboard.projectLikeStatusLoading,
	projectLikeStatus: state.dashboard.projectLikeStatus,
	companyId: state.firebase.profile.companyId,
});

export default connect(mapStateToProps, { getDashboardProjectLikeStatus })(
	ProjectLikeStatus
);
